import React from 'react';
import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    content: "Bidzora has transformed how we manage government contracts. The AI-powered insights have improved our win rate by 40% in just six months.",
    author: {
      name: 'Sarah Johnson',
      role: 'Contract Manager',
      company: 'TechGov Solutions',
      image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=2787&auto=format&fit=crop'
    }
  },
  {
    content: 'The analytics and compliance automation have been game-changers. We\'ve reduced our proposal preparation time by 60% while maintaining perfect compliance.',
    author: {
      name: 'Michael Chen',
      role: 'Business Development Director',
      company: 'Federal Systems Inc.',
      image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=2940&auto=format&fit=crop'
    }
  },
  {
    content: 'The team collaboration features have streamlined our entire process. We can now manage multiple proposals simultaneously with perfect coordination.',
    author: {
      name: 'Emily Rodriguez',
      role: 'Operations Director',
      company: 'GovTech Services',
      image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=2961&auto=format&fit=crop'
    }
  }
];

export function Testimonials() {
  return (
    <div className="relative overflow-hidden bg-gradient-to-b from-purple-50 to-white py-24 sm:py-32">
      <div className="absolute inset-0">
        <div className="absolute inset-y-0 left-0 w-1/2 bg-gradient-to-r from-purple-100/50 to-transparent"></div>
        <div className="absolute inset-y-0 right-0 w-1/2 bg-gradient-to-l from-purple-100/50 to-transparent"></div>
      </div>

      <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="bg-gradient-to-r from-purple-600 to-purple-900 bg-clip-text text-3xl font-bold tracking-tight text-transparent sm:text-4xl">
            Trusted by Leading Government Contractors
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            See how organizations are transforming their contracting process with Bidzora
          </p>
        </div>

        <div className="relative mx-auto mt-16 max-w-5xl">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.author.name}
              className={`group relative mb-12 transform rounded-2xl bg-white p-8 shadow-xl ring-1 ring-purple-900/5 transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl ${
                index % 2 === 0 ? 'ml-0 mr-12' : 'ml-12 mr-0'
              }`}
            >
              <div className="absolute -left-4 -top-4 h-8 w-8 rounded-full bg-purple-600 text-white">
                <Quote className="h-8 w-8 p-2" />
              </div>

              <div className="relative">
                <div className="flex items-center space-x-2 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star
                      key={i}
                      className="h-5 w-5 fill-purple-400 text-purple-400"
                    />
                  ))}
                </div>

                <blockquote className="text-lg font-medium text-gray-900">
                  "{testimonial.content}"
                </blockquote>

                <div className="mt-6 flex items-center space-x-4">
                  <img
                    src={testimonial.author.image}
                    alt=""
                    className="h-12 w-12 rounded-full object-cover ring-2 ring-purple-600/20"
                  />
                  <div>
                    <div className="font-medium text-gray-900">
                      {testimonial.author.name}
                    </div>
                    <div className="text-sm text-gray-500">
                      {testimonial.author.role}, {testimonial.author.company}
                    </div>
                  </div>
                </div>
              </div>

              <div className="absolute -bottom-2 -right-2 h-24 w-24 rounded-full bg-purple-100 opacity-50 blur-2xl transition-all duration-300 group-hover:bg-purple-200"></div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}